import React from 'react';
import {
  Accordion,
  Box,
  Heading,
  Text,
  Button,
  Icon,
  Flex,
} from '@chakra-ui/react';
import { FaPlus } from 'react-icons/fa';
import IntegrationItem from './IntegrationItem';
import ReskinnedIntegrationList from './ReskinnedIntegrationList';
import { useFeatureFlagFromContext } from '../../../launchdarkly';
import { returnCurrencyFromCountry } from './integrationUtils';

/**
 * Integration List Component
 */
const IntegrationList = ({
  apps,
  onAddIntegration,
  onItemClick,
  onPeriodCalTypeChange,
  onCashAcChange,
  onAppNameChange,
  onEditClick,
  onBudgetSettingsClick,
  onAuthClick,
  onDisconnectClick,
  onDateRangeChange,
  onUploaderChange,
  onResyncClick,
  editButtonLoading,
  syncButtonLoading,
  periodCalTypeFlagInt,
  setPeriodCalTypeFlagInt,
  sendEditDataFlag,
  setSendEditDataFlag,
  setOnEditComplete,
  onSetIntegrationId,
  enableBudgeting,
  yearBasedBudgeting,
  propotionalBudgeting,
  locationClassLevelBudgeting,
  limitUploader,
  excelUploadData,
  country,
  periodTypes,
  cashAccData,
  companySwitcherActive,
  apiEndpoint,
}) => {
  // Check if the showReskin feature flag is enabled
  const showReskin = useFeatureFlagFromContext('showReskin', false);

  // If showReskin is true, render the reskinned version
  if (showReskin) {
    return (
      <ReskinnedIntegrationList
        apps={apps}
        onAddIntegration={onAddIntegration}
        onItemClick={onItemClick}
        onPeriodCalTypeChange={onPeriodCalTypeChange}
        onCashAcChange={onCashAcChange}
        onAppNameChange={onAppNameChange}
        onEditClick={onEditClick}
        onBudgetSettingsClick={onBudgetSettingsClick}
        onAuthClick={onAuthClick}
        onDisconnectClick={onDisconnectClick}
        onDateRangeChange={onDateRangeChange}
        onUploaderChange={onUploaderChange}
        onResyncClick={onResyncClick}
        editButtonLoading={editButtonLoading}
        syncButtonLoading={syncButtonLoading}
        periodCalTypeFlagInt={periodCalTypeFlagInt}
        setPeriodCalTypeFlagInt={setPeriodCalTypeFlagInt}
        sendEditDataFlag={sendEditDataFlag}
        setSendEditDataFlag={setSendEditDataFlag}
        setOnEditComplete={setOnEditComplete}
        onSetIntegrationId={onSetIntegrationId}
        enableBudgeting={enableBudgeting}
        yearBasedBudgeting={yearBasedBudgeting}
        propotionalBudgeting={propotionalBudgeting}
        locationClassLevelBudgeting={locationClassLevelBudgeting}
        limitUploader={limitUploader}
        excelUploadData={excelUploadData}
        country={country}
        periodTypes={periodTypes}
        cashAccData={cashAccData}
        companySwitcherActive={companySwitcherActive}
        apiEndpoint={apiEndpoint}
        returnCurrencyFromCountry={returnCurrencyFromCountry}
      />
    );
  }

  // Otherwise, render the original version
  return (
    <Flex direction={'column'} gap={4}>
      {/* Welcome message for new users */}
      {apps !== undefined && apps.length === 0 && (
        <Box p={5} borderWidth="1px" borderRadius="lg" bg="blue.50" mb={4}>
          <Heading size="md" mb={3} color="blue.700">
            Welcome to Profit Assist!
          </Heading>
          <Text mb={3}>
            To get started, you'll need to connect your accounting software.
            This will allow Profit Assist to analyze your financial data and
            provide valuable insights.
          </Text>
          <Text mb={4} fontWeight="bold">
            Click the "Add Integration" button above to connect your accounting
            system.
          </Text>
          <Button colorScheme="blue" onClick={onAddIntegration}>
            <Icon as={FaPlus} mr={2} />
            Add Integration Now
          </Button>
        </Box>
      )}

      {apps !== undefined ? (
        <Accordion allowToggle>
          {apps !== undefined && apps.length > 0 ? (
            apps.map(item => (
              <IntegrationItem
                key={item.id}
                item={item}
                country={country}
                periodTypes={periodTypes}
                cashAccData={cashAccData}
                onItemClick={onItemClick}
                onPeriodCalTypeChange={onPeriodCalTypeChange}
                onCashAcChange={onCashAcChange}
                onEditClick={onEditClick}
                onBudgetSettingsClick={onBudgetSettingsClick}
                onAuthClick={onAuthClick}
                onDisconnectClick={onDisconnectClick}
                onDateRangeChange={onDateRangeChange}
                onUploaderChange={onUploaderChange}
                onResyncClick={onResyncClick}
                editButtonLoading={editButtonLoading}
                syncButtonLoading={syncButtonLoading}
                periodCalTypeFlagInt={periodCalTypeFlagInt}
                setPeriodCalTypeFlagInt={setPeriodCalTypeFlagInt}
                sendEditDataFlag={sendEditDataFlag}
                setSendEditDataFlag={setSendEditDataFlag}
                enableBudgeting={enableBudgeting}
                yearBasedBudgeting={yearBasedBudgeting}
                propotionalBudgeting={propotionalBudgeting}
                locationClassLevelBudgeting={locationClassLevelBudgeting}
                limitUploader={limitUploader}
                excelUploadData={excelUploadData}
                companySwitcherActive={companySwitcherActive}
                apiEndpoint={apiEndpoint}
              />
            ))
          ) : (
            <></>
          )}
        </Accordion>
      ) : (
        <></>
      )}
    </Flex>
  );
};

export default IntegrationList;
